import React from "react";
import { connect } from "react-redux";

import OurStepManager from "../../common/OurStepManager";
import PrescriptionList from "../PrescriptionList";
import ChoosePickupTime from "./ChoosePickupTime";
import OrderRefillReview from "./OrderRefillReview";
import OrderRefillConfirmation from "./OrderRefillConfirmation";
import ClosedPharmacy from "./ClosedPharmacy";
import PharmacyHeader from "../PharmacyHeader";
import ConfirmationModal from "../../common/ConfirmationModal";
import Spinner from '../../common/spinner';
import SectionLoadingError from '../../common/SectionLoadingError';
import { getAddressUrl } from "../../../helpers/location";

import * as types from "../../../constants/actionTypes";
import * as d from "../../../reducers/domainReducer";

import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import FeatureDisabled from "../../common/FeatureDisabled";

class OrderRefill extends React.Component {
    constructor(props) {
        super(props);
        const { storeNumber, rxNumber } = this.props.match.params;
        this.state = { activeStep: 0, orderRefill: null, selectedPickupDay: 0, selectedPickupDateTime: null, orderCompleted: false, activeStoreIndex: null, storeNumber, rxNumber, currentStoreIsInActive: false };
        this.baseURL = window.location.pathname;
        this.addressUrl = '#';
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.OrderRefill.ComponentDidMount", new Date(), Tools.getURLPath());
        if (!this.props.rxDown) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { hasPharmacyLogin, currentPharmacyUser, rxDown } = this.props;
        const patientId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : null;

        if (!rxDown && patientId && patientId !== this.patientId) {
            this.patientId = patientId;
            this.loadData();
        } else if (!rxDown && hasPharmacyLogin && !patientId && this.patientId !== -1) {
            this.patientId = -1;
            this.loadData();
        }
    }

    loadData = () => {
        this.setState({ orderRefill: null });
        this.props.getOrderRefills(null, this.onAvailalbeRefillsLoaded);
    }

    onAvailalbeRefillsLoaded = () => {
        const { storeNumber, rxNumber } = this.props.match.params;
        const { orderRefill } = this.props;
        if (orderRefill && storeNumber && rxNumber) {
            const list = orderRefill.list;
            if (list && list.PrescriptionRefills) {
                const refills = list.PrescriptionRefills;
                for (let storeIndex = 0; storeIndex < refills.length; storeIndex++) {
                    if (refills[storeIndex].PharmacyDetail.StoreNumber === storeNumber) {
                        const rxList = refills[storeIndex].RenewalRefills.length > 0 ? refills[storeIndex].AvailableRefills.concat(refills[storeIndex].RenewalRefills) : refills[storeIndex].AvailableRefills;
                        for (let rxIndex = 0; rxIndex < rxList.length; rxIndex++) {
                            if (rxList[rxIndex].RxNumber === rxNumber) {
                                rxList[rxIndex].selected = true;
                                list.storeNumberTargetting = storeNumber;
                                list.selectedRxCount = 1;
                                if (this.props.updateOrderRefillList) this.props.updateOrderRefillList(list);
                                this.setState({ orderRefill, activeStoreIndex: storeIndex });
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        }
        this.setState({ orderRefill });
    }

    onPickupHoursLoaded = () => {
        const { pickupHours, isPickupHoursError } = this.props;
        if (!isPickupHoursError && pickupHours && pickupHours.length) {
            this.setState({ selectedPickupDayName: pickupHours[0].DisplayDate1 });
        }
    }

    getStoreIndex(list, storeNumber) {
        for (let storeIndex = 0; storeIndex < list.length; storeIndex++) {
            if (list[storeIndex].PharmacyDetail.StoreNumber === storeNumber) {
                return storeIndex;
            }
        }
        return -1;
    }

    onRxChecked = (checked, rx, storeNumber, storeIndex) => {
        rx.selected = checked;

        const { orderRefill } = this.state;
        let { activeStoreIndex, selectedPickupDay, selectedPickupDateTime } = this.state;

        if (checked) {
            if (storeNumber === orderRefill.storeNumberTargetting) {
                orderRefill.selectedRxCount++;
            }
            else {
                this.props.getPickupHours(storeNumber, this.onPickupHoursLoaded);
                selectedPickupDay = selectedPickupDateTime = null;
                orderRefill.storeNumberTargetting = storeNumber;
                if (typeof storeIndex === 'undefined') {
                    storeIndex = this.getStoreIndex(orderRefill.list.PrescriptionRefills, storeNumber);
                }
                if (storeIndex > -1) {
                    orderRefill.selectedRxCount = 1;
                    activeStoreIndex = storeIndex;
                    this.addressUrl = getAddressUrl(orderRefill.list.PrescriptionRefills[storeIndex].PharmacyDetail.Address);
                    this.props.getPharmacyDetail(storeNumber);
                }
            }
        }
        else {
            orderRefill.selectedRxCount--;
        }

        //this.props.updateOrderRefill(orderRefill);
        this.setState({ orderRefill, activeStoreIndex, selectedPickupDay, selectedPickupDateTime });
    }

    onRxListStepped = (success) => {
        if (success && !this.state.selectedPickupDateTime) {
            this.refs.stepManager.wrappedInstance.refresh(1);
        }
    }

    updateSelectedRxList = () => {
        const { orderRefill, activeStoreIndex } = this.state;
        if (orderRefill.selectedRxCount) {
            const refills = orderRefill.list.PrescriptionRefills;
            if (refills[activeStoreIndex].PharmacyDetail.StoreNumber === orderRefill.storeNumberTargetting) {
                const allrefills = refills[activeStoreIndex].RenewalRefills.length > 0 ? refills[activeStoreIndex].AvailableRefills.concat(refills[activeStoreIndex].RenewalRefills) : refills[activeStoreIndex].AvailableRefills;
                const rxList = allrefills
                    .filter(rx => rx.selected)
                    .map(rx => { return { RxNumber: rx.RxNumber, NextFill: rx.NextFillDate, DrugName: rx.RxDrugName, NDCImageURL: rx.NDCImageURL }; });
                this.setState({ rxList });
            }
        }
    }

    onPickupDayChange = (selectedPickupDay, selectedPickupDayName) => {
        this.setState({ selectedPickupDay, selectedPickupDateTime: null, selectedPickupDayName });
    }

    onPickupTimeChange = (selectedPickupDateTime) => {
        this.setState({ selectedPickupDateTime });
    }

    submit = () => {
        const { isLoggedIn, submitIVROrder } = this.props;
        const { orderRefill, selectedPickupDateTime, rxList } = this.state;
        if (isLoggedIn && rxList && rxList.length > 0) {
            const submitData = {
                SubmitOrderItems: [{
                    StoreNumber: orderRefill.storeNumberTargetting,
                    PickupDateTime: selectedPickupDateTime,
                    RxDetails: rxList
                }]
            };
            submitIVROrder(submitData, this.onSubmitComplete);
            logUI("MBHWeb.Rx.OrderRefills.Submit", new Date(), Tools.getURLPath(), JSON.stringify({ submitData }));
        }
    }

    onSubmitComplete = (response, error) => {
        const { orderRefill } = this.props;
        if (response && response.SuccessRx && response.RenewedRx && !response.FailuresRx) {
            this.setState({
                orderCompleted: true, selectedPickupDay: 0, selectedPickupDateTime: null,
                orderRefill: { ...orderRefill, selectedRxList: [], selectedRxCount: 0 }
            });
        }
        else {
            this.setState({ orderCompleted: true });
        }
    }

    onNewRequest = (reload) => {
        this.setState({ orderCompleted: false }, () => {
            const wrappedInstance = this.refs.stepManager.wrappedInstance;
            if (reload) {
                this.loadData();
            }
            else if (wrappedInstance.onComponentDidUpdate) {
                wrappedInstance.onComponentDidUpdate();
            }
            wrappedInstance.refresh();
        });
    }

    onStepChange = (success, activeStep) => {
        if (success && typeof window !== 'undefined') {
            this.setState({ activeStep });
            window.scrollTo(0, 0);
        }

        const { activeStoreIndex, orderRefill, currentStoreIsInActive } = this.state;

        //let isStoreActive = orderRefill && orderRefill.list && orderRefill.list.PrescriptionRefills && orderRefill.list.PrescriptionRefills[activeStoreIndex] &&
        //    orderRefill.list.PrescriptionRefills[activeStoreIndex].PharmacyDetail && orderRefill.list.PrescriptionRefills[activeStoreIndex].PharmacyDetail.IsPharmacyActive ? true : false;

        let isStoreInActive = orderRefill && orderRefill.list && orderRefill.list.PrescriptionRefills && orderRefill.list.PrescriptionRefills[activeStoreIndex] &&
            orderRefill.list.PrescriptionRefills[activeStoreIndex].PharmacyDetail && typeof orderRefill.list.PrescriptionRefills[activeStoreIndex].PharmacyDetail.IsPharmacyActive !== 'undefined' && 
            orderRefill.list.PrescriptionRefills[activeStoreIndex].PharmacyDetail.IsPharmacyActive === false ? true : false;

        if (isStoreInActive !== currentStoreIsInActive) {
            this.setState({ currentStoreIsInActive: isStoreInActive });
        }
        if (isStoreInActive) {
            this.updateSelectedRxList();
        }
    }

    tryAgain = () => {
        this.setState({ orderCompleted: false });
    }

    render() {
        const { rxDown, hasPharmacyLogin, currentPharmacyUser, pharmacyDetails, waitingOnOrderRequest, pickupHoursError } = this.props;
        const { activeStep, orderRefill, selectedPickupDay, selectedPickupDayName, selectedPickupDateTime, orderCompleted, rxList, currentStoreIsInActive } = this.state;
        const rxSelected = orderRefill && typeof orderRefill.selectedRxCount !== 'undefined' && orderRefill.selectedRxCount > 0;
        const hideProgressbarSteps = orderRefill && orderRefill.list && orderRefill.list.PrescriptionRefills && orderRefill.list.PrescriptionRefills.length === 0 ? true : false;
        const proxyUser = (currentPharmacyUser && currentPharmacyUser.firstName) ? currentPharmacyUser.firstName + ' has' : 'You have';

        return !rxDown
            ? <div className="container-fluid body-content refill-container full-width">
                <div className="row">
                    {!orderCompleted
                        ? <React.Fragment>
                            {activeStep > 0 && currentStoreIsInActive
                                ? <ClosedPharmacy prescriptions={rxList} />
                                : <React.Fragment>
                                    {!rxDown && (hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId)) &&
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <PharmacyHeader />
                                            </div>
                                        </div>
                                    }
                                    <div className="col-12">
                                        <div className="row">
                                            {orderRefill && !orderRefill.waiting && !orderRefill.error && !hideProgressbarSteps ? <div className="col-12 progtrckr-divider" /> : null}
                                            <div className="col-12 maxWidth-content">
                                                <div className="step-progress">
                                                    {!orderRefill || orderRefill.waiting ?
                                                        <Spinner />
                                                        : orderRefill.error
                                                            ? <SectionLoadingError message="We're sorry, there was an error while loading your prescriptions. Please try again later." />
                                                            : !hideProgressbarSteps
                                                                ? <div className="multi-step">
                                                                    <OurStepManager ref="stepManager" baseURL={this.baseURL} backButtonCls="hidden" nextButtonCls="btn btn-primary" onStepChange={this.onStepChange}>
                                                                        <PrescriptionList steptitle="Select Prescriptions" onBackward={this.scrollToTop} isIVROrder activeRxNumber={this.state.rxNumber} activeStoreNumber={this.state.storeNumber}
                                                                            message="refill" orderRefill={orderRefill} onRxChecked={this.onRxChecked} onGoNext={this.onRxListStepped}
                                                                        />
                                                                        <ChoosePickupTime steptitle="Choose Pickup Time" onSubmit={this.updateSelectedRxList} pickupDay={selectedPickupDay}
                                                                            pickupTime={selectedPickupDateTime} onPickupDayChange={this.onPickupDayChange} onPickupTimeChange={this.onPickupTimeChange}
                                                                        />
                                                                        <OrderRefillReview steptitle="Review & Submit" continueButtonText="Submit" onSubmit={this.submit} pickupDayName={selectedPickupDayName}
                                                                            pickupTime={selectedPickupDateTime} pharmacyDetails={pharmacyDetails} addressUrl={this.addressUrl} rxList={rxList} waiting={waitingOnOrderRequest}
                                                                        />
                                                                    </OurStepManager>
                                                                </div>
                                                                : <SectionLoadingError message={proxyUser + " no prescriptions to refill"} sectionErrorClass="no-results-error" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </React.Fragment>
                        : <div className="col-12">
                            <OrderRefillConfirmation rxList={rxList} onNewRequest={this.onNewRequest} addressUrl={this.addressUrl} tryAgain={this.tryAgain} />
                        </div>
                    }
                </div>
                {/*<ConfirmationModal when={!pickupHoursError && rxSelected && !orderCompleted} /> */}
                {/*!pickupHoursError && */rxSelected && !orderCompleted && !(activeStep > 0 && currentStoreIsInActive) &&
                    <ConfirmationModal when={1 === 1} />
                }
            </div>
            : <FeatureDisabled />;
    }
}

const mapStateToProps = (state) => {
    return {
        orderRefill: state.pharmacy.orderRefill,
        waitingOnOrderRequest: state.pharmacy.isSubmitIvrOrderRequest,
        pharmacyDetails: state.pharmacy.selectedPharmacyDetails,
        pickupHours: state.pharmacy.pickupHours,
        pickupDates: state.pharmacy.pickupDates,
        isPickupHoursWaiting: state.pharmacy.isPickupHoursWaiting,
        isPickupHoursError: state.pharmacy.isPickupHoursError,
        pickupHoursError: state.pharmacy.pickupHoursError,
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        isLoggedIn: state.sso.isLoggedIn
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrderRefills: (storeNumber, callback) => dispatch({ type: types.LOAD_ORDERREFILLS_LIST_START, payload: { storeNumber }, callback }),
        getPharmacyDetail: storeNumber => dispatch({ type: types.GET_PHARMACY_BY_STORENUMBER_START, payload: { storeNumber } }),
        getPickupHours: (storeNumber, callback) => dispatch({ type: types.LOAD_PICKUP_HOURS_START, payload: { storeNumber }, callback }),
        updateOrderRefill: orderRefill => dispatch({ type: types.ORDER_REFILL_LIST_UPDATE, orderRefill }),
        submitIVROrder: (RxOrderRefillData, callback) => dispatch({
            type: types.SUBMIT_IVR_ORDER_REQUEST, payload: { RxOrderRefillData: RxOrderRefillData }, callback
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderRefill);